import { Tarifinformationen } from "@/model/Tarifinformationen";
import { Vorversicherung } from "@/model/Vorversicherung";
import { Vorschaden } from "@/model/Vorschaden";

export class FerienhausProdukt {
  wohnflaeche: number | null;
  nutzungsart = 0;
  tageUnbewohnt = 0;
  tarifinformationen = new Tarifinformationen();
  vorversicherung = new Vorversicherung();
  vorschaeden: Vorschaden[];

  constructor() {
    this.wohnflaeche = null;
    this.vorschaeden = [new Vorschaden(), new Vorschaden(), new Vorschaden(), new Vorschaden(), new Vorschaden()];
  }
}
